import {translations} from 'presentation/translations-new';

const {confirm, professional, specialty, unit, location, neighborhood} =
	translations['pt-br'].privateFlow.bookingFlow.steps;

const HEALTH_LABELS = [location, specialty, neighborhood, unit, professional, confirm];
const HEALTH_LABELS_WITHOUT_DISTRICT = [location, specialty, unit, professional, confirm];

export {HEALTH_LABELS, HEALTH_LABELS_WITHOUT_DISTRICT};
